export default __webpack_public_path__ + "static/cruiselines-royal-activities-3-e6ce01b20573d6a4d60eeebdecf16d45.jpg";